import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { defineMessages, injectIntl } from 'react-intl'
import Reference from './Reference'
import './ReferencesSection.scss'

const messages = defineMessages({
  header: {
    id: 'references.header',
    defaultMessage: 'Co řikají uživatelé?',
  },
  onePhoto: {
    id: 'references.one.photo',
    defaultMessage: 'vlada.jpg',
  },
  oneName: {
    id: 'references.one.name',
    defaultMessage: 'Ing. Vladimír Šmíro, MBA',
  },
  oneClub: {
    id: 'references.one.club',
    defaultMessage: 'FK Dukla Praha',
  },
  oneParagraphOne: {
    id: 'references.one.paragraph.one',
    defaultMessage: 'Díky Stadyum CRM jsme získali nástroj pro ucelený přehled o našich fanoušcích i ostatních skupinách týkajících se našeho klubu.',
  },
  oneParagraphTwo: {
    id: 'references.one.paragraph.two',
    defaultMessage: 'Na tomto základě s nimi můžeme cíleně komunikovat a sbírat zpětnou vazbu. Lépe tak poznáme, čím jim můžeme zpříjemnit pobyt na stadionu a přilákat je tak na další utkání našeho týmu.',
  },
  oneParagraphThree: {
    id: 'references.one.paragraph.three',
    defaultMessage: 'Přístup společnosti Stadyum je plně individuální, tudíž dokázali vyhovět specifikům našeho klubu.',
  },
})

const ReferencesSection = ({ intl }) => (
  <section className="references-section">
    <h2>{intl.formatMessage(messages.header)}</h2>
    <Grid>
      <Row>
        <Col md={6} mdOffset={3} >
          <Reference
            photo={intl.formatMessage(messages.onePhoto)}
            name={intl.formatMessage(messages.oneName)}
            club={intl.formatMessage(messages.oneClub)}
          >
            <p>
              {intl.formatMessage(messages.oneParagraphOne)}
            </p>
            <p>
              {intl.formatMessage(messages.oneParagraphTwo)}
            </p>
            <p>
              {intl.formatMessage(messages.oneParagraphThree)}
            </p>
          </Reference>
        </Col>
      </Row>
    </Grid>
  </section>
)

ReferencesSection.propTypes = {
  intl: React.PropTypes.object.isRequired,
}

export default injectIntl(ReferencesSection)



// WEBPACK FOOTER //
// ./src/browser/ReferencesSection/ReferencesSection.js